import Controller from '@ember/controller';

class SignupStepController extends Controller {

}

export default SignupStepController;
